import { eRoutes } from "../routes"
import { icons } from "./icons"

export const definitions = {
  customers: {
    indexRoute: eRoutes["/customers"],
    heading: "Customers",
    subHeading:
      "View and manage your customers and contacts. Add notes to customers, view sales, history, and more.",
    icon: icons.customers,
  },

  supportTickets: {
    indexRoute: eRoutes["/customer-support/support-tickets"],
    heading: "Support Tickets",
    subHeading:
      "Open new support tickets, view existing tickets, and see statuses of support queries.",
    icon: icons.customers,
  },

  supportTicketSettings: {
    indexRoute: eRoutes["/customer-support/settings"],
    heading: "Support Settings",
    subHeading: "Manage sources and types of support tickets",
    icon: icons.settings,
  },

  supportTicketGroups: {
    indexRoute: eRoutes["/customer-support/groups"],
    heading: "Support Ticket User Teams",
    subHeading:
      "Organise your support users into teams. Users can be assigned to multiple teams. Tickets can be assigned to teams or to individual users",
    icon: icons.users,
  },
}
